import DashBoard from "../components/DashBoard";

function DashBoardPage(props) {
    return(
        <DashBoard/>
    );
}

export default DashBoardPage;